// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px"};